import React, { useEffect, useState } from 'react';
import { Container, Wrapper } from './SkuSettings.styles';
import { getSkuCustomColumns, saveSkuCustomColumns } from 'utils/apiRequests';
import CustomColumns from './CustomColumns/CustomColumns';
import CreateKey from './CreateKey/CreateKey';
import { NotificationTypes } from 'components/Toast/constants';
import { useToastMessageContext } from 'contexts/ToastMessageContext/ToastMessageProvider';

const SkuSettings = () => {
	const { showToast } = useToastMessageContext();
	const [step, setStep] = useState(1);
	const [customColumns, setCustomColumns] = useState([]);
	const [isSavingOrFetchingColumns, setIsSavingOrFetchingColumns] = useState(
		true
	);

	useEffect(() => {
		const fetchColumns = async () => {
			const { succeeded, data } = await getSkuCustomColumns();
			if (succeeded) {
				if (data.length > 0) {
					const formatetColumns = data.map(x => {
						return {
							columnName: x.column_Name,
							description: x.description === null ? '' : x.description,
							isActive: x.iS_Active,
							isUpdated: false,
							updated_At: x.updated_At,
						};
					});
					setCustomColumns(formatetColumns);
				}
				setIsSavingOrFetchingColumns(false);
			} else {
				setIsSavingOrFetchingColumns(false);
			}
		};
		fetchColumns();
	}, []);

	const onSaveCustomColumnsHandler = () => {
		const updatedItems = customColumns.filter(x => x.isUpdated === true);
		setIsSavingOrFetchingColumns(true);
		const payload = updatedItems.map(x => {
			return {
				column_Name: x.columnName,
				description: x.description,
				iS_Active: x.isActive,
			};
		});
		saveSkuCustomColumns(payload).then(response => {
			if (response.succeeded) {
				showToast(
					'Configuration updated successfully!',
					NotificationTypes.success,
					2000
				);
				setIsSavingOrFetchingColumns(false);
				setStep(2);
			} else {
				showToast(
					'Failed to update the columns.',
					NotificationTypes.danger,
					2000
				);
				setIsSavingOrFetchingColumns(false);
			}
		});
	};

	return (
		<Wrapper>
			<Container>
				{step === 1 && (
					<CustomColumns
						customColumns={customColumns}
						isSavingOrFetchingColumns={isSavingOrFetchingColumns}
						setCustomColumns={setCustomColumns}
						onSaveCustomColumnsHandler={onSaveCustomColumnsHandler}
						onClickNext={() => setStep(2)}
					/>
				)}
				{step === 2 && (
					<CreateKey
						customColumns={customColumns}
						onBackHandler={() => setStep(1)}
					/>
				)}
			</Container>
		</Wrapper>
	);
};

export default SkuSettings;
